import script from "./openAiLives.vue?vue&type=script&setup=true&lang=ts"
export * from "./openAiLives.vue?vue&type=script&setup=true&lang=ts"

import "./openAiLives.vue?vue&type=style&index=0&id=325a9829&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-325a9829"]])

export default __exports__